import React, { RefObject, useMemo } from 'react';
import { BodyText, Input, Select } from '../../atoms';
import { Container } from './RelativeTime.styles';

import { getOptions } from './utils';
import { Unit, Timeframe, RelativeTimeTranslations } from './types';
import { defaultTranslations } from './translations';

export interface RelativeTimeProps {
  /**
   * Relative time unit
   */
  unit?: Unit;
  /**
   * Relative time value
   */
  value?: number;
  /**
   * Change event handler
   */
  onChange: (timeframe: Timeframe) => void;
  /**
   * Translations object
   */
  translations?: RelativeTimeTranslations;
  /**
   * HTML portal container used to mount elements
   */
  portalContainer?: RefObject<HTMLElement>;
}
/**
- The RelativeTime component allows the user to enter a relative timeframe.
 **/
const RelativeTime = ({
  unit = 'day',
  value,
  onChange,
  portalContainer,
  translations = defaultTranslations,
}: RelativeTimeProps) => {
  const { label } = translations;
  const options = useMemo(() => getOptions(translations), [translations]);

  return (
    <Container
      gridColumnGap={2}
      gridTemplateColumns="auto minmax(50px, max-content) minmax(90px, max-content)"
    >
      <BodyText variant="body3" color="gray.dark">
        {label}
      </BodyText>
      <Input
        value={value?.toString() || ''}
        placeholder="0"
        onChange={(e) => onChange({ unit, value: +e.target.value })}
        inputSize="small"
      />
      <Select
        options={options}
        selectedValue={unit}
        onSelect={(item) => onChange({ unit: item.value as Unit, value })}
        variant="secondary"
        selectSize="small"
        portalContainer={portalContainer}
      />
    </Container>
  );
};
export default RelativeTime;
